import axios from '@/lib/AxApi';

export default {
  getReports(params, cb)
  {
    axios.get('/rest/Reports/getReports',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/reports.js